import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
	selector: "modal-basic-footer",
	template: `<div class="modal-footer"> basic footer</div>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BasicFooterComponent {}
